// Isso é só UX (esconder/mostrar botões e telas) — não é a barreira de
// segurança real. A autorização de verdade é aplicada no back (colabi-api),
// pelo middleware Acl (app/Http/Middleware/Acl.php), que confere
// auth()->user()->hasPermissionTo(<nome da rota>) no servidor antes de
// executar qualquer ação de escrita (criar/editar/excluir usuário, etc.).
// Ou seja: mesmo que alguém chame a API direto (sem passar por essa função),
// o back rejeita se a permissão não bater.
function validatePermissions(permissions, userPermissionsList) {
  const userPermissions = userPermissionsList.map((item) => item.name);

  const valid = userPermissions.some((item) => {
    return Array.isArray(permissions)
      ? permissions.includes(item)
      : item === permissions;
  });

  return valid;
}

export default validatePermissions;
